import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { ChargesProvider } from './context/ChargesProvider'
import { ChargesWorkflowsProvider } from './context/ChargesWorkflowsProvider'
import { ChargesMain } from './components/ChargesMain'
import { GenerateInvoiceFlow } from './workflows/GenerateInvoiceFlow'

export const Charges = () => {
  return (
    <NuqsAdapter>
      <ChargesProvider>
        <ChargesWorkflowsProvider>
          <ChargesMain />
          <GenerateInvoiceFlow />
        </ChargesWorkflowsProvider>
      </ChargesProvider>
    </NuqsAdapter>
  )
}
